import React from 'react';
//import DOM from 'react-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actionCreators } from '../../store/Login';
import { bindActionCreators } from 'redux';
import { UserRoles, EditState } from '../shared/enums';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import "./Home.css";

class NoticesList extends React.Component {
    displayName = NoticesList.name;

    render() {
        var items = this.props.items.map((item, index) => {
            return (
                <NoticesListItem editMode={this.props.editMode} key={index} index={index} item={item}
                    onRemoveItem={this.props.onRemoveItem} onChangeTitle={this.props.onChangeTitle}
                    onChangeText1={this.props.onChangeText1} onChangeText2={this.props.onChangeText2}
                    isCopyHome={this.props.isCopyHome} setIsChecked={this.props.setIsChecked}
                />
            );
        });
        return (
            <ul className={"list-group " + (this.props.editMode === EditState.List ? 'notices' : 'notices notices-edit')}>{items}</ul>
        );
    }
}

class NoticesListItem extends React.Component {
    displayName = NoticesListItem.name;

    render() {
        return (
            <div>
                {this.props.editMode === EditState.Edit &&
                    <li className="list-group-item">
                        <Row>
                            <Col xs={11}>
                                <input type="text" className="form-control HomeItemInput" value={this.props.item.title} placeholder="Enter Title"
                                    onChange={(e) => this.props.onChangeTitle(this.props.index, e)}
                                />
                            </Col>
                            <Col xs={1} style={{ padding: '0px 10px 0px 10px' }}>
                                <button className="pull-right btn btn-outline-danger btn-sm deleteButton" onClick={(e) => this.props.onRemoveItem(this.props.index, e)}>
                                X
                                </button>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={11}>
                                <input type="text" className="form-control HomeItemInput" value={this.props.item.text1} placeholder="Enter Details"
                                    onChange={(e) => this.props.onChangeText1(this.props.index, e)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={11}>
                                <input type="text" className="form-control HomeItemInput" value={this.props.item.text2} placeholder="Enter Details"
                                    onChange={(e) => this.props.onChangeText2(this.props.index, e)}
                                />
                            </Col>
                        </Row>
                    </li>
                }
                {this.props.editMode === EditState.List &&
                    <li >
                        <div className="home-item home-notice-item">
                            <div className="home-notice-title">
                                {this.props.item.title}
                                {this.props.isCopyHome &&
                                    <div style={{float:'right'}}>
                                        <label htmlFor="test" />
                                        <label className="homeCheckbox">
                                            <input type="checkbox" name="test" checked={this.props.item.isChecked} onChange={(e) => this.props.setIsChecked(this.props.item)} />
                                            <span />
                                        </label>
                                    </div>
                                }
                            </div>
                            <div className="home-notice-detail">
                                {this.props.item.text1}
                            </div>
                            <div className="home-notice-detail">
                                {this.props.item.text2}
                            </div>
                        </div>
                    </li>
                }
            </div>
        );
    }
}

class NoticesHeader extends React.Component {
    displayName = NoticesHeader.name;

    render() {
        return (
            <div className="ogcText">
                {!this.props.isCopyHome &&
                    <div style={{ display: 'inline-block', float: 'right' }}>
                        {this.props.showEditForm && this.props.editMode === EditState.List &&
                            <button className="ogcButton btn-std-size" onClick={this.props.onClickEdit}>Edit</button>
                        }
                        {this.props.showEditForm && this.props.editMode === EditState.Edit &&
                            <React.Fragment>
                                <button className="ogcButton btn-std-size" onClick={this.props.onClickAdd}>Add</button>
                                <button className={(this.props.isDirty) ? "ogcButton btn-std-size" : "ogcDisabledButton btn-std-size"} onClick={this.props.onClickSubmit} disabled={!this.props.isDirty}>Submit</button>
                                <button className="ogcButton btn-std-size" onClick={this.props.onClearItems}>Clear All</button>
                                <button className="ogcButton ogcButton-brown btn-std-size" onClick={this.props.onClickCancel}>Cancel</button>
                            </React.Fragment>
                        }
                    </div>
                }
                {this.props.isCopyHome &&
                    <div style={{ display: 'inline-block', float: 'right' }}>
                        <button className="ogcButton btn-std-size" onClick={this.props.onClickSelectAll}>Select All</button>
                        <button className="ogcButton btn-std-size" onClick={this.props.onClickUnselectAll}>Unselect All</button>
                    </div>
                }
            </div>
        );
    }
}

class Notices extends React.Component {
    displayName = Notices.name;
    constructor(props) {
        super(props);

        this.responseStatus = 200;
        this.showEditForm = this.props.isAuthenticated && this.props.isEditHome &&
            (this.props.userRole === UserRoles.Administrator || this.props.userRole === UserRoles.SalesRep);

        this.state = {
            originalNotices: [],
            notices: [],
            load: false,
            editMode: EditState.List
        };
    }

    componentDidMount = async () => {
        const fetchConfig = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        };

        this.setState({ load: true });
        const response = await fetch('api/home/notices/', fetchConfig);
        if (response.ok) {
            let data = await response.json();

            var notice = data;

            notice.map((obj) => {
                obj.isChecked = false;
                return obj;
            });

            this.setState({ notices: notice, load: false });
        }
        else if (response.status === 401) {
            this.props.signOut();
        }
        else {
            var err = await response.text();
            console.log(`Failed to load Notices: ${err}.`);
            toast.error("Failed to load Notices.");
        }
    };

    onChangeTitle = (idx, e) => {
        let items = this.state.notices;
        items[idx].title = e.target.value;
        this.setState({ notices: items });
        this.props.setDirty(true);
    }
    onChangeText1 = (idx, e) => {
        let items = this.state.notices;
        items[idx].text1 = e.target.value;
        this.setState({ notices: items });
        this.props.setDirty(true);
    }
    onChangeText2 = (idx, e) => {
        let items = this.state.notices;
        items[idx].text2 = e.target.value;
        this.setState({ notices: items });
        this.props.setDirty(true);
    }

    onRemoveItem = (idx, e) => {
        var items = this.state.notices;
        items.splice(idx, 1);
        this.setState({ notices: items });
        this.props.setDirty(true);
    }

    onClearItems = () => {
        this.setState({ notices: [] });
        this.props.setDirty(true);
    }

    onClickEdit = (e) => {
        const deepCopy = this.state.notices.map(a => Object.assign({}, a));
        this.setState({ editMode: EditState.Edit, originalNotices: deepCopy });
    }

    onClickCancel = (e) => {
        this.setState({ editMode: EditState.List, notices: this.state.originalNotices });
        this.props.setDirty(false);
    }

    onClickAdd = (e) => {
        var items = this.state.notices;
        items.push({
            index: this.state.notices.length + 1,
            text: ''
        });
        this.setState({ editMode: EditState.Edit, notices: items });
        this.props.setDirty(true);
    }

    onClickSubmit = async () => {
        const fetchConfig = {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(this.state.notices)
        };

        const response = await fetch('api/home/notices/', fetchConfig);
        if (response.ok) {
            toast.success("Notices updated.");
            this.setState({ editMode: EditState.List });
            this.props.setDirty(false);
        }
        else if (response.status === 401) {
            toast.error("Unauthorized.");
            this.props.signOut();
        }
        else {
            toast.error(`Error saving Notices.`);
            console.log(`Error saving Notices: ${await response.text()}.`);
        }
    }

    setIsChecked = async (item) => {
        var notice = item;
        notice.isChecked = !notice.isChecked;

        await this.setState({ item });

        var notices = this.state.notices.filter(function (n) { return n.isChecked; });

        this.props.toggleAddToCopyHome('notices', notices);
    }

    onClickSelectAll = async () => {
        var notices = this.state.notices;

        notices.map((obj) => {
            obj.isChecked = true;
            return obj;
        });

        await this.setState({ notices });
        this.props.toggleAddToCopyHome('notices', notices);
    }

    onClickUnselectAll = async () => {
        var notices = this.state.notices;

        notices.map((obj) => {
            obj.isChecked = false;
            return obj;
        });

        await this.setState({ notices });
        this.props.toggleAddToCopyHome('notices', []);
    }

    render() {
        return (
            <div style={{ marginTop: "10px" }}>
                <NoticesHeader
                    editMode={this.state.editMode}
                    showEditForm={this.showEditForm}
                    onClickEdit={this.onClickEdit}
                    onClickCancel={this.onClickCancel}
                    onClickAdd={this.onClickAdd}
                    onClickSubmit={this.onClickSubmit}
                    isCopyHome={this.props.isCopyHome}
                    onClearItems={this.onClearItems}
                    onClickSelectAll={this.onClickSelectAll}
                    onClickUnselectAll={this.onClickUnselectAll}
                    isDirty={this.props.isDirty}
                />
                <NoticesList
                    items={this.state.notices}
                    onRemoveItem={this.onRemoveItem}
                    editMode={this.props.isCopyHome === true ? EditState.List : this.state.editMode}
                    onChangeTitle={this.onChangeTitle}
                    onChangeText1={this.onChangeText1}
                    onChangeText2={this.onChangeText2}
                    isCopyHome={this.props.isCopyHome}
                    setIsChecked={this.setIsChecked}
                />
            </div>
        );
    }
}

export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Notices));


// WEBPACK FOOTER //
// ./src/components/Home/Notices.js